module.exports = __webpack_public_path__ + "img/Layer 16.ec4c02d1.png";